
// Common scripts
require("../tablebooker");
require("../agenda/reservation-modals");
require("../specials/coupons");

require("../vendor/google-code-prettify/prettify");

// Page specific scripts
require("../pages/embed.js");

// Common styles
require("../../../css/src/tablebooker.css");

// bootstrap-colorpicker
require("../../../css/src/bootstrap-colorpicker.min.css");
require("../vendor/bootstrap/bootstrap-colorpicker.min.js");



// WEBPACK FOOTER //
// ./entries/forwebmasters.js